import { useQuery } from "@tanstack/react-query";
import { getAttdYearCount } from "../../api/attendance";
import React from "react";
import CustomTable from "../common/CustomTable";
import { yearlyAttdModalCols } from "../../utils/table/yearlyAttdModalCols";

const AttendanceYearsModalBody = () => {
  const {
    isLoading,
    data: yearlyAttdData,
    isSuccess,
  } = useQuery({
    queryKey: ["yearly_attendance"],
    queryFn: ({ signal }) => getAttdYearCount(signal),
  });
  return (
    <React.Fragment>
      {isLoading ? (
        "Loading"
      ) : isSuccess ? (
        <CustomTable data={yearlyAttdData} columns={yearlyAttdModalCols} />
      ) : (
        "Something went wrong"
      )}
    </React.Fragment>
  );
};

export default AttendanceYearsModalBody;
